import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import * as fromStep from './steps.interface';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class StepComponent {
  @Input() title: string;
  @Input() description: string;
  @Input() active = false;
}
